export const deepCopyWithoutKeys = <T>(obj: T, keysToOmit: string[]): T => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepCopyWithoutKeys(item, keysToOmit)) as T;
  }

  if (typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj as Record<string, unknown>)
        .filter(([key]) => !keysToOmit.includes(key))
        .map(([key, value]) => [key, deepCopyWithoutKeys(value, keysToOmit)]),
    ) as T;
  }

  return obj;
};
